import React, { useState } from 'react'
import { PreviousRolePopup } from './previous-role-popup'

type PreviousRoleTagProps = {
  userName?: string
  previousRoleName?: string
  checkinPath?: string
}

export function PreviousRoleTag({
  userName,
  previousRoleName,
  checkinPath,
}: PreviousRoleTagProps) {
  const [open, setOpen] = useState(false)

  const tag = (
    <span className="text-xs leading-5 font-normal rounded whitespace-nowrap flex-shrink-0 cursor-default bg-[#E7E4E4] text-[#1B1818] px-1.5 py-0.5">
      Previous role
    </span>
  )

  if (!userName || !previousRoleName) return tag

  return (
    <>
      <button
        className="text-xs leading-5 font-normal rounded whitespace-nowrap flex-shrink-0 cursor-pointer border-0 bg-[#E7E4E4] text-[#1B1818] px-1.5 py-0.5"
        onClick={() => setOpen(true)}
      >
        Previous role
      </button>
      <PreviousRolePopup
        userName={userName}
        previousRoleName={previousRoleName}
        checkinPath={checkinPath}
        open={open}
        onOpenChange={setOpen}
      />
    </>
  )
}
